<template>
  <ion-card>
    <ion-card-content>
      <p>
        Are you sure you want to reconfigure gateway {{ gateway.serialNumber }} for bridge {{ serialNumber }}?
        The process will run again and reconfigure all settings. This may take up to <strong>30 minutes</strong> and
        cause a gap in measurement readings.
      </p>
    </ion-card-content>
    <ion-card-footer>
      <ion-row>
        <ion-col size-md="6">
          <ion-button
            expand="full"
            @click="close"
          >
            Cancel
          </ion-button>
        </ion-col>
        <ion-col size-md="6">
          <ion-button
            expand="full"
            :disabled="busy"
            color="warning"
            @click="trigger"
          >
            <ion-spinner v-if="busy" />
            Proceed
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-card-footer>
  </ion-card>
</template>

<script>
import { modalController, toastController } from '@modus/ionic-vue'
import store from '../../state'

export default {
  props: {
    serialNumber: {
      type: String,
      required: true,
    },
    gateway: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    busy: false,
    attempts: 0,
  }),
  methods: {
    async trigger () {
      this.busy = true

      try {
        await store.dispatch('startGatewayScan', {
          serialNumber: this.serialNumber,
        })
      } catch (e) {
        console.log(e)
        this.busy = false
        return this.fail()
      }
      this.attempts = 3
      while (this.attempts) {
        await new Promise(resolve => setTimeout(resolve, 2000))
        try {
          await store.dispatch('reconfigureGateway', {
            serialNumber: this.serialNumber,
            hardwareAddress: this.gateway.serialNumber,
          })
        } catch (e) {
          this.attempts--
          if (this.attempts <= 0) {
            return this.fail()
          }

        }
        this.attempts = 0
      }
      await store.dispatch('fetchDevices', { serialNumber: this.serialNumber })
      return this.close()
    },
    fail(){
      toastController.create({
        message: 'Unable to reconfigure gateway',
        color: 'danger',
        duration: 3000,
      }).then(toast => toast.present())
      this.close()
    },
    close () {
      return modalController.dismiss()
    },
  },
}
</script>

<style scoped>
ion-card {
  margin: 0;
}
</style>

<style>
.pin-to-version-modal .modal-wrapper {
  background: none;
}
</style>
